export default __webpack_public_path__ + "static/media/35A32A_0_0-209d1d9e02b1bc38448a6fbeb26deed3.e88adeb3.woff";